
export const NAV_OPTIONS = ['Home','Solutions','Price','Contact'];

export const PRICING_OPTIONS = [
    {
      title: 'Standard',
      description: 'Individuals, startups, and small teams building basic mobile apps.',
      price: 29,
      buttonClass: 'outline-dark',
      buttonText: 'Start Now',
      features: [
        'Visual development tools: Drag-and-drop interface for building apps without coding.',
      	'Limited app creation: Develop one mobile app.',
      	'Basic integrations: Connect to a 10 selection of external data sources.',
  	    'Standard storage: 10GB storage capacity for app data.',
        'Community support: Access to online forums and knowledge base articles.'

      ]
    },
    {
      title: 'Pro',
      description: 'Growing businesses and teams requiring more features and customization.',
      price: 99,
      buttonClass: 'dark',
      buttonText: 'Start Now',
      features: [
        'All features from Standard plan.',
        'Increased app creation: Develop upto 3 mobile apps',
        'Advanced integrations: Connect to a wider range of external data sources and services. Upto 100',
        'Increased storage: More storage capacity for app data. 50 GB',
        'Priority support: Dedicated customer support channels for faster resolution of issues.'
      ]
    },
    {
      title: 'Enterprise',
      description: 'Large organizations with complex mobile app development  & security needs.',
      price: "Custom Pricing",
      buttonClass: 'outline-dark',
      buttonText: 'Contact Us',
      features: [
        'Unlimited app creation: Develop an unlimited number of mobile apps.',
        'Enterprise-grade integrations: Support for custom integrations with specific enterprise systems.',
        'Dedicated account manager: Personalized support and guidance from a dedicated customer success representative.',
        'Scalable storage: Highly scalable storage solutions to accommodate large volumes of app data.',
        'Advanced security features: Additional security protocols and compliance certifications to meet specific industry regulations.'

      ]
    }
  ];